export default __webpack_public_path__ + "static/banner-do-we-need-to-learn-how-to-travel-again-6003c94a53b4855ce798366c3a2a32fc.jpg";